import React, { type ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { classNames } from '../../utilities/styleUtils';
import { XMarkIcon } from '@heroicons/react/24/outline';

const tagConfig: {
  variants: {
    color: {
      clear: string[];
      lightGray: string[];
      gray: string[];
      darkBlue: string[];
      lightBlue: string[];
      orange: string[];
      purple: string[];
      red: string[];
      maroon: string[];
      darkGreen: string[];
    };
    fill: {
      solid: string[];
      outline: string[];
    };
  };
  defaultVariants: {
    color: 'gray';
    fill: 'solid';
  };
} = {
  variants: {
    color: {
      clear: ['bg-transparent', 'text-dataops-rich-black/90'],
      lightGray: ['bg-dataops-rich-black/5', 'text-dataops-rich-black/90'],
      gray: ['bg-dataops-rich-black/10', 'text-dataops-rich-black/90'],
      darkBlue: ['bg-dataops-yale-blue/30', 'text-dataops-rich-black'],
      lightBlue: ['bg-dataops-process-cyan/30', 'text-dataops-yale-blue'],
      orange: ['bg-dataops-secondary-orange/50', 'text-dataops-rich-black'],
      purple: ['bg-dataops-secondary-purple/15', 'text-dataops-secondary-purple'],
      red: ['bg-dataops-crayola-red/50', 'text-dataops-rich-black'],
      maroon: ['bg-dataops-secondary-maroon/30', 'text-dataops-secondary-maroon'],
      darkGreen: ['bg-dataops-forest-green/30', 'text-dataops-rich-black'],
    },
    fill: {
      solid: [],
      outline: [],
    },
  },
  defaultVariants: {
    color: 'gray',
    fill: 'solid',
  },
};

const tag = cva('tag', tagConfig);

interface TagProps extends VariantProps<typeof tag> {
  children?: ReactNode;
  className?: string;
  removeCallback?: () => void;
}

export default function Tag({ children = <>None</>, color = 'lightGray', className = '', removeCallback }: TagProps) {
  return (
    <div
      className={classNames(
        tag({ color }),
        'inline-flex items-center rounded-sm px-2 pt-0.5 text-xs font-normal border-b-2 border-dataops-rich-black/5  outline-dataops-process-cyan',
        className,
      )}
    >
      {children}
      {removeCallback && (
        <button
          className="ml-1 hover:text-black"
          onClick={() => {
            removeCallback();
          }}
        >
          <XMarkIcon className="h-4 w-4 text-gray-500 hover:text-gray-700" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
